import { render, staticRenderFns } from "./EditProductCharacteristics.vue?vue&type=template&id=071bbc06&"
import script from "./EditProductCharacteristics.vue?vue&type=script&lang=js&"
export * from "./EditProductCharacteristics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports